import { j as json } from "../../../../chunks/index2.js";
import { g as getHealthStatus } from "../../../../chunks/health.js";
const GET = async () => {
  const health = await getHealthStatus();
  return json(health);
};
export {
  GET
};
